const DAY_NAMES = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const MONTH_NAMES = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];

/** Splits 'YYYY-MM-DD' into a local `Date`: `new Date('YYYY-MM-DD')` parses
 *  as UTC midnight, shifting to the previous day behind UTC. */
export function parseDateOnly(dateOnly: string): Date {
    const [year, month, day] = dateOnly.split('-').map(Number);
    return new Date(year, month - 1, day);
}

/** Formats a local `Date` back to a 'YYYY-MM-DD' string. */
export function toDateOnly(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/** Today's date as 'YYYY-MM-DD', derived from local time. */
export function getTodayIso(): string {
    return toDateOnly(new Date());
}

/** "Today · Mon, Aug 3" / "Tomorrow · Tue, Aug 4" / "Wed, Aug 5". */
export function formatDayHeading(dateOnly: string, todayIso: string): string {
    const date = parseDateOnly(dateOnly);
    const today = parseDateOnly(todayIso);
    const diffDays = Math.round((date.getTime() - today.getTime()) / 86_400_000);
    const base = `${DAY_NAMES[date.getDay()]}, ${MONTH_NAMES[date.getMonth()].slice(0, 3)} ${date.getDate()}`;
    if (diffDays === 0) return `Today · ${base}`;
    if (diffDays === 1) return `Tomorrow · ${base}`;
    return base;
}

/** "Aug 3, 2026" */
export function formatShortDate(dateOnly: string): string {
    const date = parseDateOnly(dateOnly);
    return `${MONTH_NAMES[date.getMonth()].slice(0, 3)} ${date.getDate()}, ${date.getFullYear()}`;
}

/** "Mon, Aug 12, 2026": the Composer's Date field trigger label. */
export function formatWeekdayDate(dateOnly: string): string {
    const date = parseDateOnly(dateOnly);
    return `${DAY_NAMES[date.getDay()]}, ${MONTH_NAMES[date.getMonth()].slice(0, 3)} ${date.getDate()}, ${date.getFullYear()}`;
}

/** 24h 'HH:MM' -> "9:00 AM". Returns '' when no time is set. */
export function formatTime(time: string | null | undefined): string {
    if (!time) return '';
    const [hourStr, minuteStr] = time.split(':');
    const hour24 = Number(hourStr);
    const period = hour24 >= 12 ? 'PM' : 'AM';
    const hour12 = hour24 % 12 || 12;
    return `${hour12}:${minuteStr.padStart(2, '0')} ${period}`;
}

export { DAY_NAMES, MONTH_NAMES };
